"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnginePowerUnit = void 0;
/**
 * Represents the unit of power in a car engine.
 */
var EnginePowerUnit;
(function (EnginePowerUnit) {
    EnginePowerUnit["HORSEPOWER"] = "HORSEPOWER";
    EnginePowerUnit["KILOWATT"] = "KILOWATT";
})(EnginePowerUnit = exports.EnginePowerUnit || (exports.EnginePowerUnit = {}));
